import type { POStatus } from '../../types';

export type TabValue = 'details' | 'items' | 'prep-list' | 'timeline';

export interface Tab {
  value: TabValue;
  label: string;
  icon: React.ReactNode;
}

export interface WorkflowStep {
  status: POStatus;
  label: string;
  description: string;
}

export const STATUS_ORDER: POStatus[] = [
  'draft',
  'pending',
  'approved',
  'sent',
  'acknowledged',
  'shipped',
  'delivered',
];
